/* eslint-disable @typescript-eslint/no-explicit-any */
import { Api } from "../../../services/interceptor";

/** Endpoints mirror CricCenterClient's player profile tabs (see app_endpoints.dart). */
const unwrap = <T,>(payload: unknown): T => {
  if (payload && typeof payload === "object" && "data" in (payload as object)) {
    return (payload as { data: T }).data;
  }
  return payload as T;
};

export const fetchBattingAnalysis = async (playerId: string) =>
  unwrap<any>((await Api.get(`player/${playerId}/profile-batting`)).data);

export const fetchBowlingAnalysis = async (playerId: string) =>
  unwrap<any>((await Api.get(`player/${playerId}/bowling-analysis`)).data);

export const fetchFieldingAnalysis = async (playerId: string) =>
  unwrap<any>((await Api.get(`player/${playerId}/fielding-analysis`)).data);

export type ProfileMatchStatus = "IN_PROGRESS" | "SCHEDULED" | "ENDED";

export const fetchPlayerMatches = async (playerId: string, status: ProfileMatchStatus, page: number, size = 10) =>
  (
    await Api.get(`getRelevantMatchesPageable`, {
      params: { status, playerId, searchFollowingLeagues: false, page, size },
    })
  ).data as { matchResponseList?: any[]; pageNo?: number };

export const fetchPlayerTeams = async (playerId: string) =>
  ((await Api.get(`teamsByPlayerId`, { params: { playerId } })).data ?? []) as any[];

export const fetchProfileOverview = async (playerId: string) =>
  unwrap<any>((await Api.get(`player/${playerId}/profile-overview`)).data);

export const fetchPlayerSpotlight = async (playerId: string) =>
  ((await Api.get(`playerSpotlight`, { params: { playerId } })).data ?? []) as any[];
